import {useQuery} from "@tanstack/react-query"
import {studentLedgerService, studentService, studentStaffContactsServiceV3, userServiceV3} from "services"
import {BaseDepartmentId} from "types/departments"

type UserProps = {
    userId?: number
    isEnabled?: boolean
}

export const useUserDetailForMessageTemplate = ({userId, isEnabled = true}: UserProps) => {
    const query = useQuery(
        ["user-details-for-message-template", userId],
        async () => {
            return await userServiceV3.getUserDetailsForChat(userId)
        },
        {
            enabled: !!userId && isEnabled,
            initialData: {
                userDetails: null,
                profile: null,
                campusDetails: null,
                admissionAdvisor: null,
                finAidAdvisor: null,
                academicAdvisor: null,
                studentLedgerStats: null,
                studentOverallStats: null
            },
            refetchOnMount: false
        }
    )

    return {
        userData: query.data,
        isLoading: query.isFetching
    }
}
